import {
  DeepMap,
  FieldError,
  FieldValues,
  UseFormRegisterReturn,
} from "react-hook-form";
import Helper from "../../utils/helpers";
import MaterialIcon, { MtIcon } from "../material-icon/material-icon";

export type FieldErrors<TFieldValues extends FieldValues = FieldValues> =
  DeepMap<TFieldValues, FieldError>;

interface IProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  errorMessage?: string;
  icon?: MtIcon;
  label?: string;
  onIconClick?: () => void;
  onInputClick?: () => void;
  register?: UseFormRegisterReturn;
  placeholder: string;
  errors: FieldErrors;
  isError?: boolean;
  isSuccess?: boolean;
  newPassword?: boolean;
  isRequired?: boolean;
  borderRadiusStyle?: "Right" | "Left";
  labelFontSize?: string;
  rightSideText?: string;
  isShowInfoIcon?: boolean;
}

const AppInput = (props: IProps) => {
  const {
    className,
    icon,
    label,
    onIconClick,
    onInputClick,
    register,
    placeholder,
    isRequired = true,
    borderRadiusStyle,
    errors,
    isError,
    isSuccess,
    onKeyDown,
    labelFontSize,
    rightSideText,
    isShowInfoIcon = false,
    ...rest
  } = props;

  const getBorderRadiusStyle = () => {
    switch (borderRadiusStyle) {
      case "Right":
        return "12px 0 0 12px";
      case "Left":
        return "0px 12px 12px 0px";
      default:
        return "12px";
    }
  };

  return (
    <div className={`app-input-wrapper ${className}`}>
      {label && (
        <div className={`d-flex ${labelFontSize ? `${labelFontSize}` : ``}`}>
          {label}
          <label className="asterisk">{isRequired && "*"}</label>
          {isShowInfoIcon && (
            <MaterialIcon
              className="ps-1 user-select-none"
              icon="info"
              color="#8795B3"
              size={15}
            />
          )}
        </div>
      )}
      <div
        className={
          (rest.name && errors[rest.name]?.message) || isError
            ? "app-input has-danger"
            : isSuccess
            ? "app-input has-success"
            : "app-input"
        }
        style={{ borderRadius: `${getBorderRadiusStyle()}` }}
      >
        {rest.type === "number" ? (
          <input
            placeholder={placeholder}
            type={rest.type}
            min="0"
            onKeyDown={onKeyDown ?? Helper.validateInputTypeNumber}
            disabled={rest.disabled}
            className={`${props.disabled ? "app-button-disabled" : ""}`}
            onClick={onInputClick}
            onChange={rest.onChange}
            value={rest.value}
            {...register}
          />
        ) : (
          <input
            placeholder={placeholder}
            type={rest.type}
            autoComplete={
              props.newPassword ? "new-password" : props.autoComplete
            }
            disabled={rest.disabled}
            className={`${props.disabled ? "app-button-disabled" : ""}`}
            onKeyDown={onKeyDown}
            onClick={onInputClick}
            onChange={rest.onChange}
            value={rest.value}
            {...register}
          />
        )}
        {rightSideText && (
          <span className="input-icon text-secondary fs-16 fw-500 me-3">
            {rightSideText}
          </span>
        )}
        {props.icon && (
          <div className="icon" onClick={onIconClick}>
            <MaterialIcon
              icon={icon}
              color={isSuccess ? "#4FC755" : "#69768B"}
            />
          </div>
        )}
      </div>
      {rest.name && <span className="error">{errors[rest.name]?.message}</span>}
    </div>
  );
};

export default AppInput;
